import { ConditionStatus } from './types';
import {
  VHCRecordCheckBrakeItemTypes,
  VHCRecordCheckItemTypes,
  VHCRecordCheckWheelTyreItemTypes,
  VHCRecordItemGroups
} from 'api/generated';

export const statusNames = {
  [ConditionStatus.OK]: 'OK',
  [ConditionStatus.WARNING]: 'WARNING',
  [ConditionStatus.NOT_OK]: 'NOT OK',
  [ConditionStatus.NOT_TESTED]: 'NOT TESTED'
};

export const groupNameMap = {
  [VHCRecordItemGroups.ExternalOrDriveIn]: 'External / Drive In',
  [VHCRecordItemGroups.Internal]: 'Internal',
  [VHCRecordItemGroups.UnderBonnet]: 'Under Bonnet',
  [VHCRecordItemGroups.Underside]: 'Underside',
  [VHCRecordItemGroups.BrakesAndHubs]: 'Brakes & Hubs',
  [VHCRecordItemGroups.WheelsAndTyres]: 'Wheels & Tyres'
};

export const groupOrder = [
  VHCRecordItemGroups.ExternalOrDriveIn,
  VHCRecordItemGroups.Internal,
  VHCRecordItemGroups.UnderBonnet,
  VHCRecordItemGroups.Underside,
  VHCRecordItemGroups.BrakesAndHubs,
  VHCRecordItemGroups.WheelsAndTyres
];

export const vhcCheckItemNames: Record<VHCRecordCheckItemTypes, string> = {
  [VHCRecordCheckItemTypes.Engine]: 'Engine',
  [VHCRecordCheckItemTypes.Transmission]: 'Transmission',
  [VHCRecordCheckItemTypes.Horn]: 'Horn',
  [VHCRecordCheckItemTypes.ExteriorLights]: 'Exterior Lights',
  [VHCRecordCheckItemTypes.WiperBladesAndArms]: 'Wiper Blades and Arms',
  [VHCRecordCheckItemTypes.Misc]: 'Misc',
  [VHCRecordCheckItemTypes.Interior]: 'Interior',
  [VHCRecordCheckItemTypes.Interior2]: 'Interior 2',
  [VHCRecordCheckItemTypes.InteriorLampsAndDashLights]: 'Interior Lamps & Dash Lights',
  [VHCRecordCheckItemTypes.WashersAndWipersFunction]: 'Washers & Wipers Function',
  [VHCRecordCheckItemTypes.Belts]: 'Belts',
  [VHCRecordCheckItemTypes.EngineOil]: 'Engine Oil',
  [VHCRecordCheckItemTypes.Coolant]: 'Coolant',
  [VHCRecordCheckItemTypes.Screenwash]: 'Screenwash',
  [VHCRecordCheckItemTypes.BrakeFluid]: 'Brake Fluid',
  [VHCRecordCheckItemTypes.BrakeDiscsAndPadsFOrR]: 'Brake Discs & Pads (F or R)',
  [VHCRecordCheckItemTypes.Exhaust]: 'Exhaust',
  [VHCRecordCheckItemTypes.Steering]: 'Steering',
  [VHCRecordCheckItemTypes.Suspension]: 'Suspension'
};

export const vhcCheckBrakeItemNames: Record<VHCRecordCheckBrakeItemTypes, string> = {
  [VHCRecordCheckBrakeItemTypes.FrontPadsAndDiscs]: 'Front Pads & Discs',
  [VHCRecordCheckBrakeItemTypes.FrontBrakesOther]: 'Front Brakes Other',
  [VHCRecordCheckBrakeItemTypes.RearPadsAndDiscs]: 'Rear Pads & Discs',
  [VHCRecordCheckBrakeItemTypes.RearBrakesOther]: 'Rear Brakes Other',
  [VHCRecordCheckBrakeItemTypes.Misc]: 'Misc'
};

export const vhcCheckWheelTyreItemNames: Record<VHCRecordCheckWheelTyreItemTypes, string> = {
  [VHCRecordCheckWheelTyreItemTypes.FronRightTyre]: 'Front Right Tyre',
  [VHCRecordCheckWheelTyreItemTypes.FronLeftTyre]: 'Front Left Tyre',
  [VHCRecordCheckWheelTyreItemTypes.RearRightTyre]: 'Rear Right Tyre',
  [VHCRecordCheckWheelTyreItemTypes.RearLeftTyre]: 'Rear Left Tyre',
  [VHCRecordCheckWheelTyreItemTypes.SpareTyre]: 'Spare Tyre',
  [VHCRecordCheckWheelTyreItemTypes.InflationKitOrSpaceSever]: 'Inflation Kit / Space Sever',
  [VHCRecordCheckWheelTyreItemTypes.Misc]: 'Misc'
};

export const statusColors = {
  [ConditionStatus.OK]: 'text-success',
  [ConditionStatus.WARNING]: 'text-warning',
  [ConditionStatus.NOT_OK]: 'text-white',
  [ConditionStatus.NOT_TESTED]: 'text-secondary'
};

export const vhcRecordItemGroupsOrders: Record<VHCRecordItemGroups, number[]> = {
  [VHCRecordItemGroups.ExternalOrDriveIn]: [],
  [VHCRecordItemGroups.Internal]: [],
  [VHCRecordItemGroups.UnderBonnet]: [],
  [VHCRecordItemGroups.Underside]: [],
  [VHCRecordItemGroups.BrakesAndHubs]: [],
  [VHCRecordItemGroups.WheelsAndTyres]: [
    VHCRecordCheckWheelTyreItemTypes.FronLeftTyre,
    VHCRecordCheckWheelTyreItemTypes.FronRightTyre,
    VHCRecordCheckWheelTyreItemTypes.RearLeftTyre,
    VHCRecordCheckWheelTyreItemTypes.RearRightTyre,
    VHCRecordCheckWheelTyreItemTypes.SpareTyre,
    VHCRecordCheckWheelTyreItemTypes.InflationKitOrSpaceSever,
    VHCRecordCheckWheelTyreItemTypes.Misc
  ]
};
